import { render, staticRenderFns } from "./accumulationData.vue?vue&type=template&id=27331751&scoped=true&"
import script from "./accumulationData.vue?vue&type=script&lang=js&"
export * from "./accumulationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27331751",
  null
  
)

export default component.exports